<template>
  <g transform="translate(0 8)">
    <circle cx="2" cy="2" r="2" />
    <circle cx="10" cy="2" r="2" />
    <circle cx="18" cy="2" r="2" />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OptionsIcon",
});
</script>
